angular.module('dpw.directives')
    .component('dpwSecondaryNavCta', {
        bindings: {
            category: '<',
            cta: '<'
        },
        templateUrl: 'dpw-secondary-nav-cta.html',
        controller: [function () {
        }]
    });
